import _slicedToArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import classNames from "classnames";
import _ from "lodash";
import { useRouter } from "next/router";
import React from "react";
import Modal from "../../components/common/Modal";
import useMedia, { MediaSizes } from "../../hooks/useMedia";
import { getFormattedDate } from "../../utils";
import Store from "../../utils/Store";
import constants from "../../utils/constants";
import Toast from "../Toast";
import Button from "../common/Button";
import Checkbox from "../common/Checkbox";
import PrivacyPolicyContent from "./PrivacyPolicyContent";
import TermsAndConditionsContentStatic from "./TermsAndConditionsContent";
import { CONFIRMATION_CONTENT, DISCLAIMER_CONTENT, LINKS } from "./constants";
import useAgreementService from "./services";
import AwesomeIcon from "../AwesomeIcon";
import { faCircleCheck } from "@fortawesome/pro-regular-svg-icons";
var getDefaultProps = function getDefaultProps(props) {
  var dupeProps = _objectSpread({}, props);
  if (!dupeProps.closeButton) {
    dupeProps.closeButton = props.mode === "readonly" ? undefined : /*#__PURE__*/React.createElement(React.Fragment, null);
  }
  if (dupeProps.closeOnClickAway == null) {
    dupeProps.closeOnClickAway = false;
  }
  return dupeProps;
};
var TermsAndConditionsContent = function TermsAndConditionsContent(props) {
  var _agreement$accepted_t;
  var mode = props.mode,
    onDisagree = props.onDisagree;
  var isInteractive = mode === "interactive";

  // hooks
  var _React$useState = React.useState(0),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    activeIndex = _React$useState2[0],
    setActiveIndex = _React$useState2[1];
  var _React$useState3 = React.useState(new Map()),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    viewedMap = _React$useState4[0],
    setViewedMap = _React$useState4[1];
  var termsAndConditionsRef = React.useRef(null);
  var privacyPolicyRef = React.useRef(null);
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    disclaimerStatus = _React$useState6[0],
    setDisclaimerStatus = _React$useState6[1];
  var maxScroll = React.useRef(0);
  var _React$useState7 = React.useState(0),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    currentScroll = _React$useState8[0],
    setCurrentScroll = _React$useState8[1];

  // custom hooks
  var agreementQuery = useAgreementService();
  var router = useRouter();
  var isMobile = useMedia([MediaSizes.MOBILE], [true], false);
  var userInfo = Store.useState(function (s) {
    return s.userInfo;
  });
  var sectionsRead = Array.from((viewedMap === null || viewedMap === void 0 ? void 0 : viewedMap.values()) || []).every(function (value) {
    return value;
  });
  var passedCriteria = sectionsRead && disclaimerStatus;
  var agreement = _.get(userInfo, ["agreement"]);
  var agreementDatetime = (_agreement$accepted_t = agreement === null || agreement === void 0 ? void 0 : agreement.accepted_time) !== null && _agreement$accepted_t !== void 0 ? _agreement$accepted_t : "";
  var contents = [{
    id: "terms_and_conditions",
    ref: termsAndConditionsRef,
    component: TermsAndConditionsContentStatic
  }, {
    id: "privacy_policy",
    ref: privacyPolicyRef,
    component: PrivacyPolicyContent
  }];
  function submitAgreement() {
    var version = constants.TERMS_OF_USE_VERSION;
    agreementQuery.mutateAsync(version).then(function () {
      router.push({
        pathname: "/",
        query: {
          invalidate: true
        }
      });
    })["catch"](function (e) {
      Toast.error("Something went wrong. Please try again");
    });
  }
  function handleDisagree() {
    onDisagree();
  }
  function handleScroll(e) {
    var target = e.target;
    var clientHeight = target.clientHeight,
      scrollTop = target.scrollTop;
    if (!termsAndConditionsRef.current || !privacyPolicyRef.current) {
      return;
    }
    var termsAndConditionsNodeHeight = termsAndConditionsRef.current.clientHeight;
    var privacyPolicyNodeHeight = privacyPolicyRef.current.clientHeight;
    if (!maxScroll.current) {
      maxScroll.current = termsAndConditionsNodeHeight + privacyPolicyNodeHeight - clientHeight;
    }
    if (!currentScroll || currentScroll < scrollTop) {
      setCurrentScroll(scrollTop);
    }
    if (termsAndConditionsNodeHeight == null || privacyPolicyNodeHeight == null) {
      return;
    }
    var isTermsAndConditionsViewed = viewedMap.get(termsAndConditionsRef.current.id);
    var isPrivacyPolicyViewed = viewedMap.get(privacyPolicyRef.current.id);
    var hasChanged = false;
    if (scrollTop <= termsAndConditionsNodeHeight - clientHeight) {
      setActiveIndex(0);
    } else {
      setActiveIndex(1);
    }
    if (scrollTop >= termsAndConditionsNodeHeight - clientHeight && !isTermsAndConditionsViewed && scrollTop < termsAndConditionsNodeHeight + privacyPolicyNodeHeight - clientHeight) {
      hasChanged = true;
      viewedMap.set(termsAndConditionsRef.current.id, true);
    }
    if (scrollTop >= termsAndConditionsNodeHeight + privacyPolicyNodeHeight - clientHeight && !isPrivacyPolicyViewed) {
      hasChanged = true;
      viewedMap.set(privacyPolicyRef.current.id, true);
    }
    if (hasChanged) {
      setViewedMap(new Map(viewedMap));
    }
  }
  React.useEffect(function () {
    var map = new Map();
    LINKS.forEach(function (link) {
      map.set(link.id, false);
    });
    setViewedMap(map);
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "py-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames("grid pr-6 py-4", {
      "grid-cols-[214px_564px]": !isMobile,
      "pl-6 grid-cols-1": isMobile
    })
  }, mode === "readonly" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", null, ""), /*#__PURE__*/React.createElement("div", null, agreementDatetime !== "" && /*#__PURE__*/React.createElement("div", {
    className: "my-3"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-left"
  }, "ACCEPTED ON ", getFormattedDate(agreementDatetime))))), !isMobile && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("a", {
    href: "/dummy",
    className: "opacity-0"
  }, ""), /*#__PURE__*/React.createElement("ul", {
    className: "list-none mt-4"
  }, LINKS.map(function (link, index) {
    return /*#__PURE__*/React.createElement("a", {
      href: link.href,
      key: link.id,
      className: classNames({
        "bg-gray-100 dark:bg-gray-900": activeIndex === index,
        "border-b": index === LINKS.length - 1
      }, "border-t border-gray-600 py-4 grid px-5 text-left outline-none", "".concat(isInteractive ? "grid-cols-[30px_1fr]" : "grid-cols-1")),
      onClick: function onClick() {
        setActiveIndex(index);
      }
    }, isInteractive && /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faCircleCheck,
      className: classNames("text-green-600 w-6", {
        invisible: !viewedMap.get(link.id)
      })
    }), link.label);
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "terms-of-use bg-gray-100 dark:bg-gray-900 rounded-md border border-gray-600 relative overflow-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pb-4 h-[360px] sm:h-[453px]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pl-5 pr-3 scrollbar-light dark:scrollbar h-full overflow-y-scroll",
    onScroll: handleScroll
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-gray-900 dark:text-gray-100 text-left whitespace-pre-wrap"
  }, contents.map(function (content) {
    return /*#__PURE__*/React.createElement("div", {
      ref: content.ref,
      key: content.id,
      id: content.id,
      className: "py-6"
    }, content.component());
  })))), isInteractive && /*#__PURE__*/React.createElement("progress", {
    className: "w-full h-2 bg-gray-600 rounded-md block sticky bottom-0",
    max: maxScroll.current,
    value: currentScroll
  })), isInteractive && /*#__PURE__*/React.createElement("div", {
    className: "flex gap-2 items-start mt-6"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    name: "disclaimer",
    checked: disclaimerStatus,
    onChange: function onChange(value) {
      setDisclaimerStatus(value);
      if (value && !sectionsRead) {
        viewedMap.set("terms_and_conditions", true);
        viewedMap.set("privacy_policy", true);
        setViewedMap(new Map(viewedMap));
      }
    }
  }), /*#__PURE__*/React.createElement("p", {
    className: "text-md dark:text-gray-200 text-gray-700 italic text-left"
  }, DISCLAIMER_CONTENT)))), isInteractive && /*#__PURE__*/React.createElement("div", {
    className: "border-t border-gray-600"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "mr-6 gap-5 pt-4 list-none flex"
  }, /*#__PURE__*/React.createElement("li", {
    className: "ml-auto"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "w-[156px]",
    onClick: handleDisagree
  }, "Disagree")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Button, {
    className: "w-[156px]",
    isPrimary: true,
    isLoading: agreementQuery.isLoading,
    disabled: !passedCriteria,
    onClick: submitAgreement
  }, "Agree")))));
};
var ConfirmationModal = function ConfirmationModal(props) {
  var setShowConfirmationModal = props.setShowConfirmationModal;
  function onProceed() {
    Store.update(function (s) {
      s.isLogoutOpen = true;
    });
  }
  function onCancel() {
    setShowConfirmationModal(false);
  }
  return /*#__PURE__*/React.createElement(Modal, {
    className: "sm:w-6/12 lg:w-5/12",
    show: true,
    closeOnClickAway: false,
    onClose: function onClose() {
      setShowConfirmationModal(false);
    },
    title: "Rejecting license agreement"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    className: "text-left px-6 py-4"
  }, CONFIRMATION_CONTENT), /*#__PURE__*/React.createElement("ul", {
    className: "list-none flex gap-5 mr-6 mb-5"
  }, /*#__PURE__*/React.createElement("li", {
    className: "ml-auto"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "min-w-[156px]",
    onClick: onProceed
  }, "Proceed")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Button, {
    className: "min-w-[156px]",
    isPrimary: true,
    onClick: onCancel
  }, "Cancel")))));
};
var TermsAndConditionsModal = function TermsAndConditionsModal(props) {
  var _getDefaultProps = getDefaultProps(props),
    closeButton = _getDefaultProps.closeButton,
    closeOnClickAway = _getDefaultProps.closeOnClickAway,
    mode = _getDefaultProps.mode,
    _onClose = _getDefaultProps.onClose;

  // hooks
  var _React$useState9 = React.useState(true),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    showModal = _React$useState10[0],
    setShowModal = _React$useState10[1];
  var _React$useState11 = React.useState(false),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    showConfirmationModal = _React$useState12[0],
    setShowConfirmationModal = _React$useState12[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal, {
    className: "max-w-[800px]",
    show: showModal,
    closeButton: closeButton,
    closeOnClickAway: closeOnClickAway,
    onClose: function onClose() {
      _onClose();
      setShowModal(false);
    },
    title: "Terms of use"
  }, /*#__PURE__*/React.createElement(TermsAndConditionsContent, {
    onDisagree: function onDisagree() {
      setShowConfirmationModal(true);
    },
    mode: mode
  })), showConfirmationModal && /*#__PURE__*/React.createElement(ConfirmationModal, {
    setShowConfirmationModal: setShowConfirmationModal
  }));
};
export default TermsAndConditionsModal;